import { FC } from 'react'
import Typography from '@/ui/components/typography'
import {
    BannerContainer,
    BannerContent,
    BannerIcon,
    BannerActions,
    IconAndContentContainer,
} from './InfoBanner.styles'
import InfoIcon from '@/assets/images/info-icon.svg?react'
import ErrorBannerIcon from '@/assets/images/error-banner-icon.svg?react'
import { InfoBannerProps } from './InfoBanner.types'
import { useCustomTheme } from '@/core/theme'

export const InfoBanner: FC<InfoBannerProps> = ({
    title,
    description,
    primaryButton,
    secondaryButton,
    variant = 'info',
    icon,
    dataTestId,
}) => {
    const theme: any = useCustomTheme()

    const defaultIcon =
        variant === 'error' ? (
            <ErrorBannerIcon width={16} height={16} />
        ) : (
            <InfoIcon
                color={theme.colors.semantic.bannerIconColor}
                width={16}
                height={16}
            />
        )

    return (
        <BannerContainer
            data-testid={dataTestId ?? 'info-banner'}
            variant={variant}
        >
            <IconAndContentContainer>
                <BannerIcon variant={variant}>
                    {icon ?? defaultIcon}
                </BannerIcon>
                <BannerContent>
                    {title &&
                        (typeof title === 'string' ? (
                            <Typography
                                variant="s-regular"
                                color={theme.colors.semantic.bannerIconColor}
                            >
                                {title}
                            </Typography>
                        ) : (
                            title
                        ))}
                    {description && (
                        <Typography
                            variant="s-regular"
                            color={theme.colors.semantic.bannerIconColor}
                        >
                            {description}
                        </Typography>
                    )}
                </BannerContent>
            </IconAndContentContainer>
            <BannerActions>
                {primaryButton}
                {secondaryButton}
            </BannerActions>
        </BannerContainer>
    )
}

export default InfoBanner
